"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getIndexBefore_1 = __importDefault(require("../query/getIndexBefore"));

var getIndexAfter_1 = __importDefault(require("../query/getIndexAfter"));

var createViewState_1 = __importDefault(require("./createViewState"));

function getUpdateFragment(list, _start, _end) {
  var blocks = [];
  var start = getIndexBefore_1.default(list.value, _start, function (ch) {
    return ch.type === 'block-start';
  });
  var end = getIndexAfter_1.default(list.value, _end, function (ch) {
    return ch.type === 'block-end';
  });

  if (typeof start !== 'number') {
    start = _start;
  }

  if (typeof end !== 'number') {
    end = _end;
  }

  return createViewState_1.default({
    value: list.value.slice(start, end),
    entityMap: list.entityMap
  });
}

exports.default = getUpdateFragment;